import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthenticationGuard } from "microsoft-adal-angular6";

import { RedirectGuard } from "src/app/commons/guards";
import { BusinessUnitPageComponent } from "./business-unit-page/business-unit-page.component";

const routes: Routes = [
  {
    path: "",
    component: BusinessUnitPageComponent,
    canActivate: [RedirectGuard, AuthenticationGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessUnitRoutingModule {}
